module.exports = __webpack_public_path__ + "img/Pen.0eb5997a.svg";